
//@ts-nocheck
import {
  Checkbox,
  CheckboxGroup,
  CheckboxProps,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Select,
  Stack,
  Switch,
  Text,
  Textarea,
  useColorModeValue as mode,
} from "@chakra-ui/react";
import { Field } from "formik";
import React from "react";
import BirthDayField from "../../components/form-elements/BirthDayField";
import FlagPhoneInput from "../../components/form-elements/FlagPhoneInput";
import { TeacherGenderField } from "../../components/form-elements/GenderField";
import { transformPhoneInput } from "../../components/form-elements/PhoneInput";
import { capFirstLetter } from "../../utils/functions";

function generateYearOptions(future = 10) {
  let currentYear = new Date().getFullYear();
  let startYear = currentYear;
  let endYear = currentYear + future;
  let options = [];
  for (let i = startYear; i < endYear + 1; i++) {
    options = [...options, i];
  }

  return options.map((item) => ({ label: item, value: item.toString() }));
}

export const tutorFormInputProps = {
  focusBorderColor: "blue.500",
  colorScheme: "blue",
  fontSize: "16px",
  size: "lg",
  borderColor: "neutral.500",
};

let rawGenders = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];

export const FFormContext = React.createContext({
  placeholders: {},
  inputProps: tutorFormInputProps,
  genders: rawGenders,
  formControlProps: {},
});

export const useFFormContext = ({
  placeholder,
  label,
}: {
  placeholder?: string;
  label?: string;
}) => {
  const {
    placeholders,
    inputProps = tutorFormInputProps,
    genders = rawGenders,
    formControlProps = {},
    ...rest
  } = React.useContext(FFormContext);
  let plValue = (name: string) => {
    let result = placeholders[name] || { [name]: { placeholder, label } };
    return result;
  };
  let commonProps = (
    { name }: { name: any },
    { touched, errors }: { touched: any; errors: any },
  ) => ({
    ...plValue(name),
    isInvalid: Boolean(touched[name] && errors[name]),
    errorMessage: errors[name],
  });
  return { commonProps, inputProps, genders, formControlProps, ...rest };
};

export const FFormField: React.FC<{
  name: string;
  label?: string;
  country_code?: string;
  placeholder?: string;
  options?: Array<{ label: string; value: string }>;
  hideLabel?: boolean;
  years?: any[];
  onBlur?: any;
  disabled?: boolean;
  title?: any;
  isInline?: boolean;
  checkboxSpacing?: (i: number) => any;
  helpText?: string;
  optionsRender?: (node: any) => any;
  onChange?: any;
  isDisabled?: boolean;
  customKeyFunc?: (values: any, key: string) => any;
  type?:
    | "text"
    | "select"
    | "gender"
    | "checkbox"
    | "email"
    | "date"
    | "phone"
    | "radio"
    | "textarea"
    | "switch";
}> = ({
  name,
  label,
  placeholder,
  hideLabel,
  isDisabled,
  customKeyFunc = (o: any, k: string) => o[k],
  type = "text",
  options = [],
  isInline,
  years = generateYearOptions(),
  optionsRender = (o) => o,
  checkboxSpacing = (i) => ({}),
  onBlur,
  onChange,
  helpText,
  country_code = "ng",
}) => {
  const labelColor = mode("gray.700", "gray.200");
  const inputColor = mode("blue.500", "blue.200");
  const borderColor = mode("neutral.300", "neutral.100");

  let { commonProps, inputProps, genders, formControlProps } = useFFormContext({
    placeholder,
    label,
  });

  return (
    <Field name={name}>
      {({ field, form }) => {
        let fieldValue = field.value || "";
        if (type == "phone") {
          if (fieldValue) {
            fieldValue = transformPhoneInput(country_code, fieldValue);
          }
        }
        if (type == "checkbox") {
          console.log(field);
        }
        return (
          <FormControl
            flex={1}
            isInvalid={commonProps(field, form).isInvalid}
            id={name}
            {...formControlProps}
          >
            <FormContainer isInline={isInline}>
              {hideLabel ? null : (
                <FormLabel color={labelColor} htmlFor={name}>
                  {label || commonProps(field, form).label}
                </FormLabel>
              )}
              {helpText ? (
                <FormHelperText mb={2}>{helpText}</FormHelperText>
              ) : null}
              {type === "phone" ? (
                <FlagPhoneInput
                  country={country_code.toLowerCase()}
                  {...field}
                  value={fieldValue}
                  focusBorderColor={inputColor}
                  onChange={(value) => {
                    form.setFieldValue(field.name, value);
                  }}
                />
              ) : type === "gender" ? (
                <TeacherGenderField
                  {...field}
                  isInline
                  h={[0, "48px"]}
                  isDisabled={isDisabled}
                  defaultValue={field.value}
                  teacherGenderOptions={genders}
                  onChange={({ target }: { target: any }) => {
                    form.setFieldValue(field.name, target.value);
                  }}
                />
              ) : type === "radio" ? (
                <TeacherGenderField
                  {...field}
                  isInline
                  h={[0, "48px"]}
                  defaultValue={field.value}
                  teacherGenderOptions={options}
                  onChange={({ target }: { target: any }) => {
                    form.setFieldValue(field.name, target.value);
                  }}
                />
              ) : type === "select" ? (
                <Select
                  id={name}
                  value={field.value}
                  size="lg"
                  fontSize="md"
                  isDisabled={isDisabled}
                  focusBorderColor={inputColor}
                  // isSearchable
                  borderColor={borderColor}
                  placeholder={placeholder}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    form.setFieldValue(field.name, e.target.value);
                    if (onChange) {
                      onChange(e.target.value, form);
                    }
                  }}
                >
                  {commonProps(field, form).placeholder ? (
                    <option value="">
                      {commonProps(field, form).placeholder}
                    </option>
                  ) : null}
                  {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Select>
              ) : type == "checkbox" ? (
                options?.length > 0 ? (
                  <CheckboxGroup
                    size="lg"
                    // {...field}
                    {...commonProps(field, form)}
                    key={customKeyFunc(form.values, field)}
                    defaultValue={field.value}
                    isDisabled={isDisabled}
                    onChange={(val: any) => {
                      form.setFieldValue(field.name, val);
                    }}
                  >
                    {optionsRender(
                      options.map((type, i) => {
                        return (
                          <Checkbox
                            {...checkboxSpacing(i)}
                            key={i}
                            isInvalid={commonProps(field, form).isInvalid}
                            borderColor="neutral.500"
                            value={type.value}
                          >
                            <Text fontSize="md">
                              {capFirstLetter(type.label)}
                            </Text>
                          </Checkbox>
                        );
                      }),
                    )}
                  </CheckboxGroup>
                ) : (
                  <Checkbox
                    {...field}
                    defaultChecked={field.value}
                    {...commonProps(field, form)}
                    {...tutorFormInputProps}
                    onChange={(e: any) => {
                      form.setFieldValue(field.name, e.target.checked);
                    }}
                    {...checkboxSpacing(0)}
                  >
                    <Text
                      fontSize="md"
                      color={
                        commonProps(field, form).isInvalid
                          ? "red.500"
                          : "inherit"
                      }
                    >
                      {label || commonProps(field, form).label}
                    </Text>
                  </Checkbox>
                )
              ) : type == "date" ? (
                <BirthDayField
                  {...field}
                  size="lg"
                  fontSize="md"
                  isDisabled={isDisabled}
                  years={years}
                  focusBorderColor={inputColor}
                  borderColor={borderColor}
                  {...commonProps(field, form)}
                  value={field.value}
                  onChange={(value: any) => {
                    form.setFieldValue(field.name, value);
                  }}
                />
              ) : type === "switch" ? (
                <Switch
                  {...commonProps(field, form)}
                  {...tutorFormInputProps}
                  color="blue"
                  {...field}
                  size="md"
                  isChecked={field.value}
                />
              ) : type === "textarea" ? (
                <Textarea
                  name={name}
                  size="lg"
                  fontSize="md"
                  placeholder={
                    placeholder || commonProps(field, form).placeholder
                  }
                  type={type}
                  focusBorderColor={inputColor}
                  borderColor={borderColor}
                  {...inputProps}
                  {...field}
                  onBlur={onBlur || field?.onBlur}
                />
              ) : (
                <Input
                  name={name}
                  size="lg"
                  fontSize="md"
                  isDisabled={isDisabled}
                  placeholder={
                    placeholder || commonProps(field, form).placeholder
                  }
                  type={type}
                  focusBorderColor={inputColor}
                  borderColor={borderColor}
                  {...inputProps}
                  {...field}
                  onBlur={onBlur || field?.onBlur}
                />
              )}
            </FormContainer>
            <FormErrorMessage>
              {commonProps(field, form).errorMessage}
            </FormErrorMessage>
          </FormControl>
        );
      }}
    </Field>
  );
};

export const FormContainer: React.FC<{
  isInline?: boolean;
  children: React.ReactNode;
}> = ({ isInline, children }) => {
  if (isInline) {
    return (
      <Stack
        direction={{ base: "column", md: "row" }}
        spacing={{ base: "1.5", md: "8" }}
        justify="space-between"
      >
        {children}
      </Stack>
    );
  }
  return <>{children}</>;
};
